import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { useUIStore } from '@stores/index'
import { cn } from '@lib/cn'
import { SkipLink } from '@lib/a11y'

export function DashboardLayout() {
  const { sidebarCollapsed } = useUIStore()

  return (
    <div className="min-h-screen bg-[var(--color-bg-primary)]">
      <SkipLink />
      <Sidebar />
      <Header />
      <main
        id="main-content"
        tabIndex={-1}
        className={cn(
          'fixed top-16 right-0 bottom-0 overflow-auto transition-all duration-300 focus:outline-none',
          'left-0', // Default - Mobile: Content takes full width (sidebar is overlay)
          sidebarCollapsed ? 'md:left-20' : 'md:left-60' // Desktop: Push layout
        )}
      >
        <Outlet />
      </main>
    </div>
  )
}
